import {Styles} from '@/imports-files/components/countdown-timer';

export function CountdownTimer(props)
{
  return(
          <div>
            {get_timer_Section(props.minutes, props.seconds)}
          </div>

      )
}

export function get_timer_Section(minutes,seconds)
{
  if(String(seconds).length > 1)
  {
    return <div className={Styles.Timer}>0{minutes}:{seconds}</div>;
  }
  else
  {
    return <div className={Styles.Timer}>0{minutes}:0{seconds}</div>;
  }
}
